<template>

    <v-section col="col-12">
        <h3>{{ title }}</h3>
        <div class="bullets">
            <slot></slot>
        </div>
    </v-section>

</template>

<style scoped lang="scss">

    .bullets {
        display: grid;
        column-gap: 30px;
        grid-template-columns: repeat(3, 1fr);
        row-gap: 10px;
        @media (max-width: map-get($grid-breakpoints, 'lg')) {
            grid-template-columns: repeat(2, 1fr);
        }
        @media (max-width: map-get($grid-breakpoints, 'sm')) {
            grid-template-columns: repeat(1, 1fr);
        }
    }

</style>

<script>

export default {

    props: {
        title: {
            type: String,
        },
    },

}

</script>